
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.4 13.6c0-.44-.36-.8-.8-.8h-.8v-1.6H12c.88 0 1.6-.72 1.6-1.6v-8C13.6.72 12.88 0 12 0H4c-.88 0-1.6.72-1.6 1.6v8c0 .88.72 1.6 1.6 1.6h3.2v1.6h-.8c-.44 0-.8.36-.8.8H0v1.6h5.6c0 .44.36.8.8.8h3.2c.44 0 .8-.36.8-.8H16v-1.6h-5.6zM4 9.6v-8h8v8H4zm6.4-3.2H8.8V8H7.2V6.4H5.6V4.8h1.6V3.2h1.6v1.6h1.6v1.6z","fill":"#37474F"}})])
          )
        }
      }
    